import { render } from "./CheckoutPaymentForms.vue?vue&type=template&id=67ada06d"
import script from "./CheckoutPaymentForms.vue?vue&type=script&lang=js"
export * from "./CheckoutPaymentForms.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__